

exports.__esModule = true;
exports.getSplitScreenFlags = exports.submitButtonTextKey = exports.upopConfirmButtonTextKey = exports.pageTitleProps = exports.pageTitle = undefined;

var _constants = require('../constants/constants');

var _constants2 = _interopRequireDefault(_constants);

var _logger = require('xo-beaver/dist/logger');

var _commonLib = require('../lib/commonLib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var pageTitle = function pageTitle(models, mode, fiMode) {
    if (models.checkoutInputData.isEbayTxn()) {
        // prox signup flow title
        return 'signupAccountCreation.heading';
    } else if (fiMode === 'bank') {
        return 'largeScreenPayment.bankTitle';
    } else if (models.checkoutCart.isWalletTokenization()) {
        return 'common.createPayPalSubTitleSignup';
    } else if (mode === 'signup') {
        return 'largeScreenPayment.signupTitle';
    } else {
        return 'largeScreenPayment.title';
    }
};

var pageTitleProps = function pageTitleProps(models, subject) {

    var WALLET_RESPONSE = {
        'google': 'signup.androidPayTitleProp',
        'Samsung': 'signup.tokenizedWalletInfoTitleProp',
        'default': 'signup.androidPayTitleProp' // fallback to android pay
    };

    if (models.checkoutCart.isWalletTokenization()) {

        _logger.$logger.info(subject + '_WALLET_TOKENIZATION');

        if (WALLET_RESPONSE[subject]) {
            return WALLET_RESPONSE[subject];
        } else {
            // Oops something terrible happened! API response does't have our key. return default instead
            return WALLET_RESPONSE['default'];
        }
    } else {
        return 'largeScreenPayment.titleProp';
    }
};

var upopConfirmButtonTextKey = function upopConfirmButtonTextKey(flags) {
    var buttonTextKey = 'confirmUpop.confirmAndContinueToMerch';
    if (flags.wpsFlow) {
        buttonTextKey = 'confirmUpop.confirmAndContinue';
    } else if (flags.commit) {
        buttonTextKey = 'confirmUpop.confirmAndPay';
    }
    return buttonTextKey;
};

var submitButtonTextKey = function submitButtonTextKey(flags, showNewSignupComplianceExp) {
    var getCommitOrContinueText = function getCommitOrContinueText(mode) {
        return _constants2['default'].submitButtonTextKeyMap[mode][showNewSignupComplianceExp ? 'US' : 'ROW'][flags.commit ? 'commit' : 'notCommit'];
    };

    var buttonTextKey = void 0;

    if (flags.show_poma_ui) {
        buttonTextKey = getCommitOrContinueText(flags.poma_flow ? 'pomaSignup' : 'guest');
    } else {
        buttonTextKey = getCommitOrContinueText(flags.mode === 'signup' ? 'signup' : 'guest');
    }

    return buttonTextKey;
};

var getSplitScreenFlags = function getSplitScreenFlags(mode) {

    var splitScreenExp = _commonLib.SplitScreen.getSplitScreenExperience();

    // Initial values - SplitScreenFlags
    var ssFlags = {
        showSplitScreenExp: false,
        prefillEmailFromCookie: false,
        showSplitScreenFGAWarning: false,
        isSplitScreenUserChoseGuest: splitScreenExp.userChoseGuest
    };

    // If we do not find ulPage param in the url
    if (!splitScreenExp.isULSplitScreenExp) {
        return ssFlags;
    }

    // Enable forced signup only for "optional Signup" (mode = guest) flow
    if (splitScreenExp.isAccountMatched && mode === 'guest') {

        // We use flags.mode to change view, where as this.mode is a static
        // value throughout lifecycle of app
        // this.mode is carried from pages/xo-guest and pages/xo-signup
        ssFlags.prefillEmailFromCookie = true;
    } else if (splitScreenExp.isAccountMatched && mode === 'signup') {
        /*
         * This case can only be hit when user changes his default selected country
         * DETAILS:
         * User should not be given an option to redirect to xoon on UL, when UL has
         * detected that the user has a matching member account and the token is
         * only eligible for signup.
         * HOW TO HIT THIS CASE:
         * So, when user lands on xoon with a matching member account on UL, and the
         * token is eligible for optional signup, we show forced guest - mode=guestonly
         * But, when user changes his default selected country to a different country,
         * and the new country FGA rule says the token is eligible for forced signup,
         * then we need to show a specific error message to user.
         */

        _logger.$logger.info('checkout_fpti', {
            from: mode,
            to: 'process_change_cntry',
            int_error_code: '0',
            int_error_description: 'FGA_splitscreen_warning_msg_shown'
        });

        ssFlags.showSplitScreenFGAWarning = true;
    } else {
        ssFlags.showSplitScreenExp = true;
        ssFlags.prefillEmailFromCookie = true;
    }

    return ssFlags;
};

exports.pageTitle = pageTitle;
exports.pageTitleProps = pageTitleProps;
exports.upopConfirmButtonTextKey = upopConfirmButtonTextKey;
exports.submitButtonTextKey = submitButtonTextKey;
exports.getSplitScreenFlags = getSplitScreenFlags;


_logger.$logger;

_commonLib.SplitScreen;


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/lib/pageProps.js
// module id = ./components/xo-guest-components/src/guest/lib/pageProps.js
// module chunks = 1